// removed by extract-text-webpack-plugin
module.exports = {"Container":"Messages__Container__IMUKF","TitleContainer":"Messages__TitleContainer__2_j4c","Image":"Messages__Image__15VDZ","ChatContainer":"Messages__ChatContainer__34bwY","Chat":"Messages__Chat__3Dmhy","MessageSender":"Messages__MessageSender__P_Na2","Title":"Messages__Title__13ExZ","Line":"Messages__Line__3-FQV","HalfLine":"Messages__HalfLine__17Slh","InputContainer":"Messages__InputContainer__3n1vQ","SendButton":"Messages__SendButton__3PXQ0"};


//////////////////
// WEBPACK FOOTER
// ./src/Containers/Messages/Messages.css
// module id = 6564
// module chunks = 0